<template>
    <ul class="vue-navigation-list menu" :class="[{'open': open && depth > 1}, classNames]" v-show="open">
        <cp-navigation-list-item
            v-for="item in items"
            :key="item.id"
            :item="item"
            :active-id="activeId"
            :parent-id="parentId"
            @navigation-link-clicked="handleClick"
        ></cp-navigation-list-item>
    </ul>
</template>

<script>
import NavigationListItem from "./NavigationListItem";

export default {
    name: "NavigationList",

    components: {
        'cp-navigation-list-item': NavigationListItem
    },

    props: {
        items: {
            type: Array,
            required: true,
        },

        depth: {
            type: Number|String,
        },

        open: {
            type: Boolean,
            default: true,
        },

        parentId: {
            type: String,
        },

        activeId: {
            type: null|String,
            default: null,
        },

        classNames: {
            type: String,
            default: '',
        }
    },

    methods: {
        handleClick(payload) {
            this.$emit('navigation-link-clicked', {...payload})
        }
    }
}
</script>

<style scoped>
ul {
    padding-left: 1.5rem;
}
</style>